  export const ServiceData = [{
    title: "AWS",
    des: "Meridian Consulting is an experienced AWS partner helping businesses explore limitless possibilities in cloud environments for different verticals. Our expertise in AWS in tourism services helps in automating infrastructure management by merging your IT infrastructure with the AWS environment. We offer assistance in everything ranging from cloud hosting to devops and AI.",
    btnLink: "/services/aws",
    icon: "/assets/img/icon/aws.svg",
  },
  {
    title: "Azure",
    des: "Meridian Consulting is a trusted Microsoft Azure partner that offers stable applications and streamline processes at optimized costs to increase productivity in businesses. From project planning, strategizing, and development to offering maintenance and support; our team of experts provides infrastructure management in the Azure cloud environment.",
    btnLink: "/services/azure",
   icon: "/assets/img/icon/azure.svg",
  },

    {
    title: "Data Management",
    des: "Data Management Services uses data collected by companies to get actionable insights out of it. This includes ingesting, storing, organising and using data securely and efficiently. Data management practice at Meridian Consulting helps organisations in managing data and creating accurate reports, alerts, and dashboards to satisfy reporting needs of regulatory compliance reporting.",
    btnLink: "/services/data-management",
     icon: "/assets/img/icon/dm.svg",
  },

    {
    title: "Cloud Management",
    des: "Cloud management is an integral part of the cloud environment along with the setup and integration services. Keeping this in mind, Meridian Consulting offers effective management services to ease immediate complexities and help customers manage their cloud infrastructure. From cloud deployment to cloud migration services, we bring to you end-to-end managed cloud services to fulfill the requirements of a cloud computing environment.",
    btnLink: "/services/cloud",
 icon: "/assets/img/icon/cm.svg",
  },
  {
    title: "CyberSecurity Services",
    des: "Meridian Consulting offers a variety of services ranging from information security consulting to assessing and testing applications and networks for companies operating in various industries. Using top-notch tools and technologies, we help you in securing digital /assets to meet the growing demands of the threat landscape.",
    btnLink: "/services/cybersecurity",
    icon: "/assets/img/icon/cybersecurity.svg",
  },
]
export const BlogData = [
  {   title: " AWS Security Services To Consider",
      des: "Meridian Consulting offers a variety of services ranging from information security consulting to assessing and testing applications...",
   
    btnLink: "/blog/aws",
    img: "/assets/img/awscard.png",
  },
   {   title: " Azure Storage: Features and Services",
    des: "Data Management Services uses data collected by companies to get actionable insights out of it. This includes ingesting, storing... ",
    btnLink:"/blog/azure",
    img: "/assets/img/azurecard.png",
  },
  {   title: "Cloud Management: Trends To Keep Up in 2020",
    des: "Cloud management is an integral part of the cloud environment along with the setup and integration services. Keeping this in mind...",
    btnLink: "/blog/cloud-management",
    img: "/assets/img/cmcard.png",
  }
]

export const AzureBlog = {
    title: "Azure Storage: Features and Services",
    mainImg: "/assets/img/b-azure.png",
    bannerImg: "/assets/img/bg/azurebanner.png",
    des: "Microsoft Azure is one of the top cloud service providers in the IT industry. With the introduction of new approaches in the cloud, it is important to pay attention to services like storage to benefit most. When it comes to storage, Microsoft Azure serves as the ideal cloud storage solution with high scalability, durability, and availability requirements for modern applications. </br>We bring to you all the features and storage services offered by Microsoft Azure that makes it the first choice partner for cloud storage services.",
    featrued: [
        { 
          title: "Features of Azure Storage",
          des: "",
          img: "",
          listData: [
            "Azure Storage is highly durable and available which means data can be easily safeguarded from general hardware failures. You are also offered the option of replicating data across multiple data centers and geographical regions which adds extra protection from natural disasters.",
            "The entire data is written with encryption, you are offered higher security as compared to other cloud services. The companies can also avail of fine-grained control over access privileges taking the security upper notch.",
            "Challenges like data storage and performance in modern applications can be easily handled with a highly scalable Azure storage design.",
            "Inherent advantages of hardware maintenance, updates, and resolution of critical issues are provided along with the facility of storage as a fully managed service."
          ],  
        },
          { 
          title: "Types of Storage Services",
          des: "<b>Azure Blob:</b> Azure Blob is one of the most prominent storage services which makes for an ideal choice as an object storage solution for the cloud. Large volumes of unstructured data such as binary data are stored using blob storage. From documents or images, all sorts of media can be directly e-soft to a browser and files can be stored for distributed access with the help of blob storage. Whether it is streaming audio and video or storing data for disaster recovery, backup, or restoring; blob storage is the perfect choice for all.</br></br><b>Azure Files:</b> One of the most important types of storage services offered by Azure is the Azure Files. Network file shares with high availability for access through the standard server message block protocol are established with the help of this service. This results in enabling multiple virtual machines to share similar files with reading and writing access. This service allows you to access files from anywhere in the world using a URL with a shared access signature (SAS) token. Ideally, Azure files are used for on-premises applications and file configurations.</br></br><b>Azure Queue: </b>This service is prominently used for storing and retrieving messages ranging up to 64 kb in size. The application of this service can be seen in the storage of lists of messages for asynchronous processing.",
          img: "",
          listData: [
           
          ],  
        },
        
    ]
}

export const AwsBlog = {
    bannerImg: "/assets/img/bg/awsbanner.png",
    title: "AWS Security Services To Consider",
    mainImg: "/assets/img/b-aws.png",
    des: "With an increase in cloud adoption, the concerns about security have increased too as organizations are facing severe threats from hackers. It is important to protect data against theft or security breaches and overcome challenges like data privacy, non-authentication, integrity, and online attacks like phishing, DDoS, SQL Injection, etc.</br>Keeping all these challenges in mind, we bring to you prominent AWS Security Services to consider for your data protection:",
    featrued: [
        { 
          title: "AWS WAF",
          des: "AWS Web Application Firewall helps in monitoring web requests forwarded to Application Load Balancer, CloudFront, or Amazon API Gateway. The web requests can be allowed or blocked as per rules and conditions with the help of AWS WAF which sits about Cloudfront or ALB. If you are looking for a service to block web requests, WAF toys for you as it also works within rules and conditions formulated by you.</br></br>For instance, AWS WAF can be used to serve content for the public request and block requests from attackers at the same time. The same IPs continuously hitting the website with multiple web requests can be blocked using WAF. The feature also allows you to count requests matching the properties specified by you. The web requests based on new properties can be allowed and blocked using this firewall along with avoiding accidental blocking of traffic to the website.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "AWS Inspector",
          des: "The automated security assessment service offered by AWS to make security and compliance of applications deployed better is the AWS Inspector. It automatically assessors applications not just for vulnerabilities but also for deviations for best practices and offers a list of security issues. The assessment is done on each EC2 instance so that the best practices for security can be verified. Since it is a tag-based and agent-based security assessment service, the template looks for EC2 instances with specific tags so that the assessment targets can be identified.",
          img: "",
          listData: [
            
          ],  
        },
         { 
          title: "AWS Key Management Service",
          des: "As the name suggests, AWS Key Management Service is used to create and manage keys to control encryption usage across applications. It is integrated with other services to simplify key usage to encrypt data across AWS workloads. It is a fully managed service that utilizes symmetric encryption for securing data which means the same key is used for encryption as well as decryption of data. ",
          img: "",
          listData: [
           
          ],  
        },
    ]
}
export const CloudBlog = {
      bannerImg: "/assets/img/bg/cmbanner.png",
    mainImg: "/assets/img/b-cm.png",
    title: "Cloud Management: Trends Up in 2020",
    des: "Cloud management has evolved rapidly, with one in three companies embracing it for enhanced compliance, security, and efficiency. Here are key 2020 trends shaping the future of cloud management.",
    featrued: [
        { 
          title: "Cloud Cost Optimization",
          des: "Cloud management prioritizes security over everything else especially when it’s about securing data in the public cloud. Previously the term security was defined as access control, permissions, and policy creation by the cloud management providers but times have changed now.",
          img: "",
          listData: [
           
          ],  
        },
          { 
          title: "Hybrid Infrastructure Management",
          des: "Using a hybrid approach can prove to be highly beneficial for the infrastructure. A careful balance of both on-cloud and on-premise infrastructure is going to be the future of cloud management. If you have a cohesive cloud management system, the infrastructures can be converged easily giving you a better knowledge of data handling and improving security and visibility.",
          img: "",
          listData: [
           
          ],  
        },
            { 
          title: "Consolidating Tools",
          des: "With continuous rapid consolidation of the tools market, the software market is bound to be transformed. Cloud management vendors are being acquired by the software companies to offer cloud management services alongside the normal output.",
          img: "",
          listData: [
            
          ],  
        },
            { 
          title: "Multi-Cloud Management",
          des: "The multi-cloud revolution has arrived and it’s here to stay. Many organizations have started opting for a multi-cloud environment. The companies benefit from services like better workload flexibility and no vendor lock-in.",
          img: "",
          listData: [
            
          ],  
        },
            {  
          title: "Cloud Cost Optimization",
          des: "With multi-cloud adoption rising, managing IaaS budgets has become challenging. Cloud cost optimization helps track spending, forecast expenses, and improve resource efficiency for smarter budgeting.",
          img: "",
          listData: [
            
          ],  
        },
        
    ]
}

export const AWSService = {
    bannerImg: "/assets/img/bg/sawsb.png",
    title: "AWS",
    des: "",
    mainImg: "/assets/img/s-aws1.png",
    featrued: [
        { 
          title: "Transform Your Business with Expert AWS Solutions",
          des: "Meridian Consulting is an experienced AWS partner helping businesses explore limitless possibilities in cloud environments for different verticals. Our expertise in AWS in tourism services helps in automating infrastructure management by merging your IT infrastructure with the AWS environment. We offer assistance in everything ranging from cloud hosting to devops and AI.</br></br>Our team of experts provide you with suitable and budget friendly plans using a pay-for-value pricing model. Experience increased innovation and improved reliability along with the fine tuning of on-premise IT infrastructure. For a complicated hosting environment, you are also offered end to end server management.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "Enterprise Application Management",
          des: "AWS has become a popular choice for enterprises as a secure extension of data centres. The applications are easily integrated using AWS Directory Service on-premise systems in a seamless manner. A team of experts provide you the right tools to iterate and implement the right technologies required for development and deployment.",
          img: "/assets/img/s-aws2.png",
          listData: [
          ],  
        },
         { 
          title: "Hybrid Cloud Services",
          des: "Meridian Consulting reposit best hybrid cloud architecture to integrate on premise data and cloud operations across AWS and on-premise environments using a common set of cloud tools, services, and application programming interfaces. The potential business goals can be achieved with easy deployment of services and secure and compliant hybrid cloud architectures.",
          img: "",
          listData: [
          ],  
        },
         { 
          title: "AWS Consulting",
          des: "Being a certified consulting partner, AWS uses the power of cloud to help businesses in smoothed integration, deployment, and management of on premises architecture to AWS. From detailed assessment and planning of models to offering strategic roadmap development, our team brings to you innovative solutions to strengthen business models.",
          img: "",
          listData: [
          ],  
        }
        
    ]
}
export const AzureService = {
     bannerImg: "/assets/img/bg/sazureb.png",
    title: "Azure",
    des: "",
    mainImg: "/assets/img/s-azure1.png",
    featrued: [
        { 
          title: "Transform Your Business with Expert AWS Solutions",
          des: "Meridian Consulting is an experienced AWS partner helping businesses explore limitless possibilities in cloud environments for different verticals. Our expertise in AWS in tourism services helps in automating infrastructure management by merging your IT infrastructure with the AWS environment. We offer assistance in everything ranging from cloud hosting to devops and AI.</br></br>Our team of experts provide you with suitable and budget friendly plans using a pay-for-value pricing model. Experience increased innovation and improved reliability along with the fine tuning of on-premise IT infrastructure. For a complicated hosting environment, you are also offered end to end server management.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "Enterprise Application Management",
          des: "AWS has become a popular choice for enterprises as a secure extension of data centres. The applications are easily integrated using AWS Directory Service on-premise systems in a seamless manner. A team of experts provide you the right tools to iterate and implement the right technologies required for development and deployment.",
          img: "/assets/img/s-azure2.png",
          listData: [
          ],  
        },
           { 
          title: "Hybrid Cloud Services",
          des: "Meridian Consulting reposit best hybrid cloud architecture to integrate on premise data and cloud operations across AWS and on-premise environments using a common set of cloud tools, services, and application programming interfaces. The potential business goals can be achieved with easy deployment of services and secure and compliant hybrid cloud architectures.",
          img: "",
          listData: [
          ],  
        },
           { 
          title: "AWS Consulting",
          des: "Being a certified consulting partner, AWS uses the power of cloud to help businesses in smoothed integration, deployment, and management of on premises architecture to AWS. From detailed assessment and planning of models to offering strategic roadmap development, our team brings to you innovative solutions to strengthen business models.",
          img: "",
          listData: [
          ],  
        },    
     ]
}
export const DataManagementService = {
        bannerImg: "/assets/img/bg/sdmb.png",

    des: "",
    mainImg:"/assets/img/s-dm1.png" ,
    featrued: [
        { 
          title: "Smart Data Management for Actionable Insights and Compliance",
          des: "Data Management Services uses data collected by companies to get actionable insights out of it. This includes ingesting, storing, organising and using data securely and efficiently. Data management practice at Meridian Consulting helps organisations in managing data and creating accurate reports, alerts, and dashboards to satisfy reporting needs of regulatory compliance reporting.</br></br>We enable organizations to build reliable reporting frameworks by delivering real-time dashboards, automated alerts, and compliance-ready reports. Our solutions support regulatory requirements while improving decision-making and operational efficiency. By integrating modern data tools and governance strategies, we help businesses maintain data integrity, enhance security, and unlock the true value of their data /assets.",
          img: "", 
          listData: [
          ],  
        },
          { 
          title: "Data Governance and Quality Management",
          des: "Our expertise in data management practices offers strategic governance designs and formulates policies for user roles, responsibilities, and rights. Taking care of data related standards and metrics, we offer data quality assurance. Various data cleansing activities are carried out to eliminate incomplete, obsolete, or duplicate data.",
          img: "/assets/img/s-dm2.png",
          listData: [
          ],  
        },
          { 
          title: "Data Integration and Migration",
          des: "Our team offers assistance in integrating data into a centralised data storage by extracting, transforming, loading setup, and ETL automation. Data warehouse and data lakes are created using business intelligence and big data solution architecture. After critical and sensitive data assessment, data migration plans are constructed for migration automation. Data completeness is tested after the migration process.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "Data Security and Architecture Audit",
          des: "Various data risk assessments are carried out to create security policies and standards. In order to improve data security, we use technology stack selection to prioritize data. We also ensure data architecture audits through the data warehouse and BI health checks to monitor security and performance.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "Data Management Software Implementation and Data Management as a Service",
          des: "Data Management Technology stack is outlined and data management software is integrated into the existing data environment. Data Management as a Service also referred to as DMaaS offers ready-to-use data management infrastructure and data backup.",
          img: "",
          listData: [
          ],  
        },
        
        
    ]
}  
export const CloudManagementService = {
    title: "Cloud Management",
        bannerImg: "/assets/img/bg/scmb.png",

    des: "",
    mainImg: "/assets/img/s-cm1.png",
    featrued: [
        { 
          title: "Efficient Cloud Management for Scalable Growth",
          des: "Cloud management is an integral part of the cloud environment along with the setup and integration services. Keeping this in mind, Meridian Consulting offers effective management services to ease immediate complexities and help customers manage their cloud infrastructure. From cloud deployment to cloud migration services, we bring to you end-to-end managed cloud services to fulfill the requirements of a cloud computing environment.</br>Our automation and self-service capabilities not only help in delivering value but also ensure your utmost security and compliance standards. Using quality pricing, delivery, and management models; We bring to you rapid cloud deployments configured and tailored to your business needs.",
          img: "",
          listData: [
            
          ],  
        },
          { 
          title: "Cloud Hosting",
          des: "The cloud hosting services offered by Meridian Consulting are focused on improving business flexibility, agility, and scalability at lower costs. We help you in determining top cloud services from public clouds, private clouds, and hybrid clouds to fit your business needs whether available in AWS, Azure, or any other cloud environment.",
          img: "/assets/img/s-cm2.png",
          listData: [
            
          ],  
        },
        { 
          title: "Cloud Migration",
          des: "The cloud migration services help you in migrating applications to a cloud environment to bring scalability and high performance to your business operations. From identified areas for improving critical business functions to offering solutions to mitigate risk, maximize performance, and invoke robust processes; we take care of all the migration needs.",
          img: "",
          listData: [
            
          ],  
        },
        { 
          title: "Cloud Support",
          des: "Cloud support services constantly monitor the overall cloud environment to help organizations adopt cloud technologies without any hassle. With the help of our technical expertise, personalized approach, and proven processes, cloud readiness is assessed to deliver stability to the cloud environment.",
          img: "",
          listData: [
           
          ],  
        },
     
        
    ]
} 
export const CyberSecurityService = {
        bannerImg: "/assets/img/bg/scbb.png",

    title: "CyberSecurity Services",
    des: "",
    mainImg: "/assets/img/s-cb1.png",
    featrued: [
        { 
          title: "Comprehensive Cybersecurity Solutions for Modern Businesses",
          des: "Meridian Consulting offers a variety of services ranging from information security consulting to assessing and testing applications and networks for companies operating in various industries. Using top-notch tools and technologies, we help you in securing digital /assets to meet the growing demands of the threat landscape.</br></br>Businesses are offered unmatched services in security assessment and planning, application security, and network protection. From providing information security consulting to offering assistance in mobile device management and application management, you are offered a variety of cybersecurity services. We also ensure your constant compliance with regulations and standards like HIPAA, PCI DSS, GDPR, etc.",
          img: "",
          listData: [
          ],  
        },
          { 
          title: "Cloud Security",
          des: "Meridian Consulting is well equipped with the necessary experience required to tune special security components for security management and threat protection across various cloud workloads. We offer constant and efficient monitoring of the security of all cloud applications along with the analysis of event logs from the cloud solutions. Necessary security policies are applied to meet the required security standards.",
          img: "/assets/img/s-cb2.png",
          listData: [
          ],  
        },
        { 
          title: "Web Application Security",
          des: "Our team of experts ensure proper protection of all web services including websites and applications. Carrying out vulnerability tests to check the proper encryption and ensuring that security measures are applied, your web application security is our priority. Valuable recommendations are provided to the customers after the evaluation results to improve the protection level of web solutions.",
          img: "",
          listData: [
          ],  
        },
         { 
          title: "Mobile Device Management and Application Management",
          des: "Appropriate device management policies and control measures are implemented to install new mobile applications and ensure the compliance of corporate and personal devices to internal security policies. Corporate Information sharing can be controlled by keeping a check on apps and mobile devices being used.",
          img: "",
          listData: [
          ],  
        },
         
    ]
} 